export default {
      id: "twitter-usage",
      viewBox: "0 0 488 457",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#twitter",
      toString: function () {
        return this.url;
      }
    }